"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDateOfLatestWarning = exports.getOppositionErrors = exports.canMoveToOpen = exports.canRegisterInRKI = exports.isAutoRKIIgnoreUnresolvedOppositionsEnabled = exports.isAutoRKIOpenEnabled = exports.isAutoRKIEnabled = exports.RKIRegistrationError = exports.foundationCodeMapper = exports.RKIRegistries = exports.Registry = exports.RequiredAge = exports.RequiredAmount = void 0;
const moment_1 = __importDefault(require("moment"));
const __1 = require("..");
const customers_1 = require("../customers");
const documents_1 = require("../documents");
const helpers_1 = __importDefault(require("../economy/helpers"));
const vouchers_1 = require("../economy/vouchers");
const interactions_1 = require("../interactions");
const templates_1 = require("../templates");
const updates_1 = require("../updates");
var RequiredAmount;
(function (RequiredAmount) {
    RequiredAmount[RequiredAmount["RKIOPEN"] = 100000] = "RKIOPEN";
    RequiredAmount[RequiredAmount["RKICLOSED"] = 20000] = "RKICLOSED";
})(RequiredAmount || (exports.RequiredAmount = RequiredAmount = {}));
var RequiredAge;
(function (RequiredAge) {
    RequiredAge[RequiredAge["RKI"] = 18] = "RKI";
})(RequiredAge || (exports.RequiredAge = RequiredAge = {}));
var Registry;
(function (Registry) {
    Registry["RKI"] = "RKI";
})(Registry || (exports.Registry = Registry = {}));
var RKIRegistries;
(function (RKIRegistries) {
    RKIRegistries["OPEN"] = "open";
    RKIRegistries["CLOSED"] = "closed";
})(RKIRegistries || (exports.RKIRegistries = RKIRegistries = {}));
const foundationCodeMapper = (foundation) => {
    if (!foundation) {
        return '-1';
    }
    switch (foundation.type) {
        case documents_1.DocumentTypes.DOM:
            return customers_1.FoundationCode.dom;
        case documents_1.DocumentTypes.FORLIG:
            return customers_1.FoundationCode.forlig;
        case documents_1.DocumentTypes.SKYLDERKLAERING:
            return customers_1.FoundationCode.skylderklæring;
        default:
            return '-1';
    }
};
exports.foundationCodeMapper = foundationCodeMapper;
var RKIRegistrationError;
(function (RKIRegistrationError) {
    RKIRegistrationError["AlreadyRegistered"] = "AlreadyRegistered";
    RKIRegistrationError["MissingWarning"] = "MissingWarning";
    RKIRegistrationError["WrongCurrency"] = "WrongCurrency";
    RKIRegistrationError["WarningLetterWasReturned"] = "WarningLetterWasReturned";
    RKIRegistrationError["EmailWarningWasNeverDelivered"] = "EmailWarningWasNeverDelivered";
    RKIRegistrationError["WarningIsOlderThanOneYear"] = "WarningIsOlderThanOneYear";
    RKIRegistrationError["FoundationCouldNotBeMapped"] = "FoundationCouldNotBeMapped";
    RKIRegistrationError["FoundationDateCouldNotFound"] = "FoundationDateCouldNotFound";
    RKIRegistrationError["UnresolvedOpposition"] = "UnresolvedOpposition";
    RKIRegistrationError["OppositionFound"] = "OppositionFound";
    RKIRegistrationError["NoRegistryFound"] = "NoRegistryFound";
    RKIRegistrationError["FoundationAmountCouldNotBeFound"] = "FoundationAmountCouldNotBeFound";
    RKIRegistrationError["FoundationAmountTooSmall"] = "FoundationAmountTooSmall";
    RKIRegistrationError["NameTooLong"] = "NameTooLong";
})(RKIRegistrationError || (exports.RKIRegistrationError = RKIRegistrationError = {}));
const isAutoRKIEnabled = (tenant, creditor) => {
    var _a;
    let autoDebtRegister = false;
    if (creditor.settings.autoDebtRegister !== undefined) {
        autoDebtRegister = creditor.settings.autoDebtRegister;
    }
    else {
        if (((_a = tenant.settings) === null || _a === void 0 ? void 0 : _a.autoDebtRegister) !== undefined) {
            autoDebtRegister = tenant.settings.autoDebtRegister;
        }
    }
    return autoDebtRegister;
};
exports.isAutoRKIEnabled = isAutoRKIEnabled;
const isAutoRKIOpenEnabled = (tenant, creditor) => {
    var _a;
    let autoRKIOpen = false;
    if (creditor.settings.autoRKIOpen !== undefined) {
        autoRKIOpen = creditor.settings.autoRKIOpen;
    }
    else {
        if (((_a = tenant.settings) === null || _a === void 0 ? void 0 : _a.autoRKIOpen) !== undefined) {
            autoRKIOpen = tenant.settings.autoRKIOpen;
        }
    }
    return autoRKIOpen;
};
exports.isAutoRKIOpenEnabled = isAutoRKIOpenEnabled;
const isNameTooLong = (debtorUsers) => {
    const debtorToBeRegistred = debtorUsers.find((debtor) => debtor.relation === 'debtor');
    return !!(debtorToBeRegistred && (debtorToBeRegistred.details.name || '').length >= 60);
};
const isAutoRKIIgnoreUnresolvedOppositionsEnabled = (tenant, creditor) => {
    var _a;
    let autoRKIIgnoreUnresolvedOppositions = false;
    if (creditor.settings.autoRKIIgnoreUnresolvedOppositions !== undefined) {
        autoRKIIgnoreUnresolvedOppositions =
            creditor.settings.autoRKIIgnoreUnresolvedOppositions;
    }
    else {
        if (((_a = tenant.settings) === null || _a === void 0 ? void 0 : _a.autoRKIIgnoreUnresolvedOppositions) !== undefined) {
            autoRKIIgnoreUnresolvedOppositions =
                tenant.settings.autoRKIIgnoreUnresolvedOppositions;
        }
    }
    return autoRKIIgnoreUnresolvedOppositions;
};
exports.isAutoRKIIgnoreUnresolvedOppositionsEnabled = isAutoRKIIgnoreUnresolvedOppositionsEnabled;
const canRegisterInRKI = (kase, debtorUsers, caseVouchers, interactions, documents, updates, templates, autoRKIOpen, autoRKIIgnoreUnresolvedOppositions) => {
    const errors = [];
    let foundationCode;
    let foundationDate;
    let foundationAmount;
    if (isAlreadyRegistered(debtorUsers, kase.id, kase.caseId)) {
        errors.push(RKIRegistrationError.AlreadyRegistered);
    }
    if (isNameTooLong(debtorUsers)) {
        errors.push(RKIRegistrationError.NameTooLong);
    }
    if (kase.currency !== __1.Currency.DKK) {
        errors.push(RKIRegistrationError.WrongCurrency);
    }
    const foundations = (0, documents_1.getFoundations)(documents);
    const registry = getRegsitry(caseVouchers, foundations, autoRKIOpen || false);
    if (registry === RKIRegistries.OPEN) {
        const { openRKIErrors, openRKIFoundationDate, openRKIFoundationAmount, openRKIFoundationCode, } = getOpenRKIErrorsAndDetails(foundations);
        errors.push(...openRKIErrors);
        foundationCode = openRKIFoundationCode;
        foundationDate = openRKIFoundationDate;
        foundationAmount = openRKIFoundationAmount;
    }
    if (registry === RKIRegistries.CLOSED) {
        errors.push(...getClosedRKIErrors(interactions, updates, templates, autoRKIIgnoreUnresolvedOppositions));
    }
    if (registry === null) {
        errors.push(RKIRegistrationError.NoRegistryFound);
    }
    return {
        ready: errors.length === 0,
        errors,
        details: { registry, foundationCode, foundationDate, foundationAmount },
    };
};
exports.canRegisterInRKI = canRegisterInRKI;
const canMoveToOpen = (debtorUsers, document) => {
    const registrations = debtorUsers.reduce((acc, d) => d.details.rkiReports
        ? acc.concat(d.details.rkiReports.filter((r) => r.referenceId === d.userId))
        : acc, []);
    const isRegisteredInClosed = !!registrations.length &&
        registrations[0].registry === customers_1.RKIRegistries.CLOSED;
    const openRKI = getOpenRKIErrorsAndDetails([document]);
    if (document.refIdType === documents_1.RefIdTypes.CASE &&
        isRegisteredInClosed &&
        openRKI.openRKIErrors.length === 0) {
        return true;
    }
    return false;
};
exports.canMoveToOpen = canMoveToOpen;
const getRegsitry = (caseVouchers, foundations, autoRKIOpen) => {
    if (autoRKIOpen &&
        foundations.length > 0 &&
        -helpers_1.default.overview.balance(caseVouchers) >= RequiredAmount.RKIOPEN) {
        return RKIRegistries.OPEN;
    }
    if (-helpers_1.default.overview.balanceCategory(caseVouchers, vouchers_1.VoucherCategory.PRINCIPAL) >= RequiredAmount.RKICLOSED &&
        -helpers_1.default.overview.balance(caseVouchers) >= RequiredAmount.RKICLOSED) {
        return RKIRegistries.CLOSED;
    }
    return null;
};
const isAlreadyRegistered = (debtorUsers, caseSeqId, caseId) => {
    return (debtorUsers.filter((debtorUser) => {
        var _a;
        if ((_a = debtorUser.details.rkiReports) === null || _a === void 0 ? void 0 : _a.length) {
            return debtorUser.details.rkiReports.some((report) => {
                var _a;
                return ((_a = report.journalId) === null || _a === void 0 ? void 0 : _a.split('-')[0]) === caseSeqId.toString() ||
                    report.caseId === caseId;
            });
        }
        return false;
    }).length > 0);
};
const getRKIWarningErrors = (interactions, updates, templates) => {
    const sixMonthsAgo = (0, moment_1.default)().subtract(6, 'months').add(1, 'days');
    const fourteenDaysAgo = (0, moment_1.default)().subtract(14, 'days');
    const errors = [];
    const rkiWarningTemplateIds = templates
        .filter((template) => {
        return template.tags.some((tag) => tag.tag === templates_1.TemplateTag.RKIWarning);
    })
        .map((template) => template.templateId);
    const alreadyWarnedUpdates = updates.filter((u) => u.updateTypeId === updates_1.UpdateType.RKIWARNED &&
        sixMonthsAgo.isBefore((0, moment_1.default)(u.pausedAt)) &&
        fourteenDaysAgo.isAfter((0, moment_1.default)(u.pausedAt)));
    if (alreadyWarnedUpdates.length) {
        return errors;
    }
    const outgoingInteractions = interactions.filter((i) => i.direction === interactions_1.Direction.OUTGOING);
    const rkiWarningInteraction = outgoingInteractions.filter((interaction) => {
        if (interaction.templateId) {
            return rkiWarningTemplateIds.includes(interaction.templateId);
        }
        return false;
    });
    if (!rkiWarningInteraction.length) {
        errors.push(RKIRegistrationError.MissingWarning);
    }
    const rkiWarningInteraction1 = rkiWarningInteraction.filter((interaction) => {
        if (interaction.type === interactions_1.InteractionType.Letter) {
            if (interaction.events.length) {
                return false;
            }
        }
        return true;
    });
    if (!rkiWarningInteraction1.length && rkiWarningInteraction.length) {
        errors.push(RKIRegistrationError.WarningLetterWasReturned);
    }
    const rkiWarningInteraction2 = rkiWarningInteraction1.filter((interaction) => {
        if (interaction.type === interactions_1.InteractionType.Email) {
            const deliveredEvents = interaction.events.filter((event) => event.type === 'delivered');
            if (deliveredEvents.length) {
                return true;
            }
            return false;
        }
        return true;
    });
    if (!rkiWarningInteraction2.length && rkiWarningInteraction1.length) {
        errors.push(RKIRegistrationError.EmailWarningWasNeverDelivered);
    }
    const currentRKIWarnings = rkiWarningInteraction2.filter((interaction) => {
        if (sixMonthsAgo.isBefore((0, moment_1.default)(interaction.createdAt))) {
            return true;
        }
        return false;
    });
    if (!currentRKIWarnings.length && rkiWarningInteraction2.length) {
        errors.push(RKIRegistrationError.WarningIsOlderThanOneYear);
    }
    return errors;
};
const getOpenRKIErrorsAndDetails = (foundations) => {
    const openRKIErrors = [];
    const foundation = foundations[0];
    const foundationCode = (0, exports.foundationCodeMapper)(foundation);
    const foundationsDate = documents_1.documentsWhichIsFoundations.signingNotRequired.includes(foundation.type)
        ? foundation.date
        : documents_1.documentsWhichIsFoundations.signingRequired.includes(foundation.type)
            ? foundation.signedAt
            : null;
    const amount = foundation.meta.amount;
    if (foundationCode === '-1') {
        openRKIErrors.push(RKIRegistrationError.FoundationCouldNotBeMapped);
    }
    if (!foundationsDate) {
        openRKIErrors.push(RKIRegistrationError.FoundationDateCouldNotFound);
    }
    if (!amount) {
        openRKIErrors.push(RKIRegistrationError.FoundationAmountCouldNotBeFound);
    }
    else {
        if (amount < RequiredAmount.RKIOPEN) {
            openRKIErrors.push(RKIRegistrationError.FoundationAmountTooSmall);
        }
    }
    return {
        openRKIErrors,
        openRKIFoundationCode: foundationCode,
        openRKIFoundationDate: foundationsDate || undefined,
        openRKIFoundationAmount: amount || undefined,
    };
};
const getClosedRKIErrors = (interactions, updates, templates, autoRKIIgnoreUnresolvedOppositions) => {
    const errors = [];
    errors.push(...getRKIWarningErrors(interactions, updates, templates));
    errors.push(...(0, exports.getOppositionErrors)(interactions, updates, autoRKIIgnoreUnresolvedOppositions));
    return errors;
};
const getOppositionErrors = (interactions, updates, autoRKIIgnoreUnresolvedOppositions) => {
    const errors = [];
    const incomingInteractions = interactions.filter((interaction) => interaction.type === interactions_1.InteractionType.Phone ||
        (interaction.direction === interactions_1.Direction.INCOMING &&
            ![interactions_1.InteractionType.Note, interactions_1.InteractionType.ClientNote].includes(interaction.type)));
    let unresolvedOpposition = false;
    const oppositions = incomingInteractions.filter((interaction) => {
        var _a;
        const interactionUpdates = updates.filter((update) => update.refId === interaction.id &&
            [
                updates_1.UpdateType.OPPOSITION.toString(),
                updates_1.UpdateType.NOTOPPOSITION.toString(),
            ].includes(update.updateTypeId));
        if (interactionUpdates.length) {
            interactionUpdates.sort((a, b) => {
                if ((0, moment_1.default)(a.createdAt) > (0, moment_1.default)(b.createdAt)) {
                    return -1;
                }
                else if ((0, moment_1.default)(a.createdAt) < (0, moment_1.default)(b.createdAt)) {
                    return 1;
                }
                return 0;
            });
            if (((_a = interactionUpdates[0]) === null || _a === void 0 ? void 0 : _a.updateTypeId) === updates_1.UpdateType.OPPOSITION) {
                return true;
            }
        }
        else {
            unresolvedOpposition = true;
        }
        return false;
    });
    const unmappedOppositions = updates.filter((update) => {
        if (update.updateTypeId === updates_1.UpdateType.OPPOSITION.toString()) {
            return !update.refId;
        }
        return false;
    });
    if (!autoRKIIgnoreUnresolvedOppositions && unresolvedOpposition) {
        errors.push(RKIRegistrationError.UnresolvedOpposition);
    }
    if (oppositions.length || unmappedOppositions.length) {
        errors.push(RKIRegistrationError.OppositionFound);
    }
    return errors;
};
exports.getOppositionErrors = getOppositionErrors;
const getDateOfLatestWarning = (interactions, updates, templates) => {
    const sixMonthsAgo = (0, moment_1.default)().subtract(6, 'months').add(1, 'days');
    const fourteenDaysAgo = (0, moment_1.default)().subtract(14, 'days');
    const rkiWarningTemplateIds = templates
        .filter((template) => {
        return template.tags.some((tag) => tag.tag === templates_1.TemplateTag.RKIWarning);
    })
        .map((template) => template.templateId);
    const outgoingInteractions = interactions.filter((i) => i.direction === interactions_1.Direction.OUTGOING);
    const rkiWarningInteraction = outgoingInteractions.filter((interaction) => {
        if (interaction.templateId) {
            return rkiWarningTemplateIds.includes(interaction.templateId);
        }
        return false;
    });
    const rkiWarningInteraction1 = rkiWarningInteraction.filter((interaction) => {
        if (interaction.type === interactions_1.InteractionType.Letter) {
            if (interaction.events.length) {
                return false;
            }
        }
        return true;
    });
    const rkiWarningInteraction2 = rkiWarningInteraction1.filter((interaction) => {
        if (interaction.type === interactions_1.InteractionType.Email) {
            const deliveredEvents = interaction.events.filter((event) => event.type === 'delivered');
            if (deliveredEvents.length) {
                return true;
            }
            return false;
        }
        return true;
    });
    const currentRKIWarnings = rkiWarningInteraction2.filter((interaction) => {
        const fourteenDaysAgo = (0, moment_1.default)().subtract(14, 'days');
        if (fourteenDaysAgo.isBefore((0, moment_1.default)(interaction.createdAt))) {
            return false;
        }
        return true;
    });
    const newestRKIWarning = currentRKIWarnings.sort((a, b) => {
        if ((0, moment_1.default)(a.createdAt) > (0, moment_1.default)(b.createdAt)) {
            return -1;
        }
        else if ((0, moment_1.default)(a.createdAt) < (0, moment_1.default)(b.createdAt)) {
            return 1;
        }
        return 0;
    })[0];
    const warnedUpdates = updates.filter((u) => u.updateTypeId === updates_1.UpdateType.RKIWARNED &&
        sixMonthsAgo.isBefore((0, moment_1.default)(u.pausedAt)) &&
        fourteenDaysAgo.isAfter((0, moment_1.default)(u.pausedAt)));
    const newestRKIWarningUpdate = warnedUpdates.sort((a, b) => {
        if ((0, moment_1.default)(a.createdAt) > (0, moment_1.default)(b.createdAt)) {
            return -1;
        }
        else if ((0, moment_1.default)(a.createdAt) < (0, moment_1.default)(b.createdAt)) {
            return 1;
        }
        return 0;
    })[0];
    if (newestRKIWarning && newestRKIWarningUpdate) {
        if ((0, moment_1.default)(newestRKIWarning.createdAt).isAfter((0, moment_1.default)(newestRKIWarningUpdate.pausedAt))) {
            return (0, moment_1.default)(newestRKIWarning.createdAt).format();
        }
        return (0, moment_1.default)(newestRKIWarningUpdate.pausedAt).format();
    }
    else if (newestRKIWarningUpdate) {
        return (0, moment_1.default)(newestRKIWarningUpdate.pausedAt).format();
    }
    return newestRKIWarning
        ? (0, moment_1.default)(newestRKIWarning.createdAt).format()
        : undefined;
};
exports.getDateOfLatestWarning = getDateOfLatestWarning;
//# sourceMappingURL=index.js.map